webpackJsonp([70144966829960],{

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/imbibe.3bdf2641.jpg";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _imbibe = __webpack_require__(536);
	
	var _imbibe2 = _interopRequireDefault(_imbibe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	    return _react2.default.createElement(
	        'div',
	        { id: 'contact' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'IMBIBE - Contact Us'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Generic Page' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: '' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        'Contact Us'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We would enjoy the opportunity to meet and learn more about your business need. Perhaps we\u2019ll be a good fit to work together, just reach out when you\u2019re ready to start a conversation.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'image' },
	                            _react2.default.createElement('img', { src: _imbibe2.default, alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'details' },
	                            _react2.default.createElement(
	                                'section',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'contact-method' },
	                                    _react2.default.createElement('span', { className: 'icon alt fa-home' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        '2035 Manchester St NE #300, ',
	                                        _react2.default.createElement('br', null),
	                                        'Atlanta, GA 30324',
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: 'https://www.google.com/maps/dir/?api=1&destination=2035+Manchester+St+NE+%23300,+Atlanta,+GA+30324', target: '_blank' },
	                                            'Driving Directions'
	                                        ),
	                                        ' ',
	                                        _react2.default.createElement('br', null),
	                                        _react2.default.createElement(
	                                            'a',
	                                            { href: 'http://dev.imbibe.info/images/imbibe-directions.pdf', target: '_blank' },
	                                            'Download PDF'
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'section',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'contact-method' },
	                                    _react2.default.createElement('span', { className: 'icon alt fa-envelope' }),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'mailto:hello@imbibe.info' },
	                                        'hello@imbibe.info'
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'section',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'contact-method' },
	                                    _react2.default.createElement('span', { className: 'icon alt fa-phone' }),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'tel:4048225035' },
	                                        '(404) 822-5035'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('iframe', { src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3315.0739143657775!2d-84.36523738490091!3d33.81040558067247!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f505d04c8771d1%3A0x92ad6d6ca8c8ee81!2sImbibe+Design!5e0!3m2!1sen!2sus!4v1521303930630', width: '600', height: '450', frameBorder: '0', allowfullscreen: true })
	            )
	        )
	    );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-77dbe10cd56b4757dbec.js